import { render, staticRenderFns } from "./SubscribeInMediaPackage.vue?vue&type=template&id=21a0dc50&"
import script from "./SubscribeInMediaPackage.vue?vue&type=script&lang=js&"
export * from "./SubscribeInMediaPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports